'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 10,
    bottom: 50,
    left: 65,
    right: 20
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 5,
    yAxisShift: 2,
    yAxisLabelShift: 55,
    beltPartHeight: 0.0416
  };
};
module.exports = Params;